import * as R from 'ramda'

import installRetailOrder from './retailOrder/installClient.js'
import installCashier from './cashier/installClient.js'

export default R.pipe(installRetailOrder, installCashier)
